import { useCallback } from 'react'
import { useCreateApiNotification, useFetchRefactored } from 'civic-champs-shared/api/hooks'

export default function useApproveGroupMembers(refresh?: () => void) {
  const [request, { loading }] = useFetchRefactored()
  const createNotification = useCreateApiNotification({ isNew: true })

  const approveMembers = useCallback(
    async (groupId: number, members: { person: { id: number }; status: { code: string } }[]) => {
      const personIds = members.filter(member => member.status.code === 'applicant').map(member => member.person.id)
      if (!personIds.length) {
        createNotification('Approving members').onError('No applicants selected', new Error('No applicants selected'))
        return
      }

      const notification = createNotification('Approving members')
      try {
        await request({
          method: 'post',
          url: `/groups/${groupId}/membership_actions`,
          config: {
            body: {
              type: 'approved',
              personIds,
            },
          },
        })
        notification.onSuccess(`Successfully approved ${personIds.length} member${personIds.length === 1 ? '' : 's'}`)
        refresh?.()
      } catch (error) {
        notification.onError('Error approving members', error)
      }
    },
    [createNotification, refresh, request],
  )

  return { approveMembers, loading }
}
